import React, { Component, ReactElement } from "react";
import { getLocalValue, LocaleValue } from "@eres/core/dist/LocaleValue";
import { LocaleUtil, StringUtil } from "@eres/core";
import { UserNotification } from "@10x/sso";
import { navigate } from "@my-dld/utils/StoreUtils";
import { getNotificationIconClass, getNotificationUrl, getNotificationWrapperClass, getResolutionLabel } from "@my-dld/utils/UserNotificationHandler";

interface Props {
	notification: UserNotification;
	wrapperClass?: string;
	alertClass?: string;
	showResolve?: boolean;
}

interface State {
	resolutionLink?: string;
	resolutionLabel?: LocaleValue;
	title?: string;
	subTitle?: string;
	icon?: string;
	wClass?: string;
}

class UserNotificationView extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {};
	}

	static getDerivedStateFromProps( nextProps: Readonly<Props>, _prevState: State ) {
		const { notification } = nextProps;
		let title = getLocalValue( notification.title );
		if ( StringUtil.isEmptyStringOrNull( title ) ) {
			title = notification.code;
		}
		let subTitle = getLocalValue( notification.subTitle );
		if ( StringUtil.isEmptyStringOrNull( subTitle ) ) {
			subTitle = "";
		}
		return {
			icon: getNotificationIconClass( notification ),
			wClass: getNotificationWrapperClass( notification ),
			resolutionLink: getNotificationUrl( notification ),
			resolutionLabel: getResolutionLabel( notification ),
			title,
			subTitle,
		};
	}

	onResolveClicked = () => {
		const { notification, showResolve } = this.props;
		const { resolutionLink, } = this.state;
		if ( resolutionLink && showResolve )
			navigate( resolutionLink!, undefined, { notification: notification } );
	};

	render() {
		const { notification, wrapperClass, alertClass, showResolve } = this.props;
		const { icon, subTitle, title, wClass, resolutionLink, resolutionLabel } = this.state;


		let Resolution: ReactElement | undefined = undefined;
		if ( showResolve && !StringUtil.isEmptyStringOrNull( resolutionLink ) ) {
			Resolution = (
				<span className="alert-action">
                    <button
	                    type="button" className="btn btn-sm btn_1"
	                    onClick={ this.onResolveClicked }>
                        { LocaleUtil.getLocalValue( resolutionLabel ) }
                    </button>
                </span>
			);
		}
		return (
			<div
				className={ "alert alert-user-notification " + wClass + " " + ( alertClass ?? "" ) + ( "user-alert-code-" + notification.code ) }>
				<span className="alert-icon-wrapper"><i className={ "alert-user-notification-icon " + icon }/></span>
				<span className="alert-body">
                    <span className="alert-title">{ title } </span>
                    <p>{ subTitle }</p>
                </span>
				{ Resolution }
			</div>
		);
	}
}

export default UserNotificationView;
